import React from 'react'
import LegalLayout, { Section, Para, Accent } from '../components/LegalLayout'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import LocationOnIcon from '@mui/icons-material/LocationOn'

const Row = ({ icon, label, value, href }) => (
  <div className='bg-[#141414] rounded-md p-4 flex items-start gap-3'>
    <span className='text-[#2ea759] mt-1'>{icon}</span>
    <div className='flex flex-col'>
      <p className='text-[#8f9094] text-sm'>{label}</p>
      {href
        ? <a href={href} className='text-base sm:text-lg hover:text-[#2ea759] duration-200 break-words'>{value}</a>
        : <p className='text-base sm:text-lg break-words'>{value}</p>}
    </div>
  </div>
)

const ContactUs = () => {
  return (
    <LegalLayout title='Contact Us' lastUpdated='25 June 2026'>
        <Para>
          Have a question about our services, a payment, or a refund? We’d love to hear from you. Reach
          out to <Accent>Nilay Singh</Accent> through any of the channels below and we’ll get back to
          you as soon as possible.
        </Para>

        <Section heading='Get in Touch'>
          <div className='flex flex-col gap-4'>
            <Row icon={<EmailIcon />} label='Email' value='snilay011@gmail.com' href='mailto:snilay011@gmail.com' />
            <Row icon={<PhoneIcon />} label='Phone' value='+91 9810237655' href='tel:+919810237655' />
            <Row icon={<LocationOnIcon />} label='Address' value='Shipra Riviera, Indirapuram, Ghaziabad, Uttar Pradesh, India' />
          </div>
        </Section>

        <Section heading='Business Hours'>
          <Para>Monday to Saturday, 10:00 AM – 7:00 PM (IST). We aim to respond to all enquiries within 1–2 business days.</Para>
        </Section>
    </LegalLayout>
  )
}

export default ContactUs
